<template>
    <div>
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">访客类型</div>
                        </el-col>

                    </el-row>
                    <el-row style="text-align: left">
                        <el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData">
                            <el-form-item label="名称">
                                <el-input @change="changeIndex"   placeholder="名称" v-model="searchForm.name" prefix-icon="el-icon-user" clearable >
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="searchData()">查询</el-button>
                                <el-button  type="primary" v-if="isAuth('fktype:add')" @click="addOrUpdate()" icon="el-icon-plus" style="display: inline;">添加</el-button>
                                <el-button  type="danger" v-if="isAuth('fktype:delete')" @click="deleteHandle()">批量删除</el-button>
                            </el-form-item>
                        </el-form>
                    </el-row>
                </div>

                <el-table
                        :data="dataList" @selection-change="selectionChangeHandle" v-loading="loading"  style="text-align: center; width: 100%;">
                    <el-table-column
                            type="selection"
                            header-align="center"
                            align="center"
                            width="50">
                    </el-table-column>
                    <el-table-column prop="name" label="名称" >
                    </el-table-column>
                    <el-table-column prop="orderNum" label="排序号" >
                    </el-table-column>
                    <el-table-column label="操作" >
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" v-if="isAuth('fktype:update')"  @click="addOrUpdate(scope.row.id)">修改</el-button>
                            <el-button type="text" size="mini" v-if="isAuth('fktype:delete')"  @click="deleteHandle(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                </el-pagination>
            </el-card>
        </div>
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="searchData"></add-or-update>


    </div>
</template>
<script>
    import {
        Vue,
        Component
    } from 'vue-property-decorator'

    import AddOrUpdate from './type-add-or-update'
    @Component({
        name: 'tGuestType',
        components:{
            AddOrUpdate
        }
    })
    export default class tGuestType extends Vue {
        addOrUpdateVisible=false
        currentNo = 1;
        pageSize = 10;
        pageTotal = 0;
        dataList=[]
        showInfoVisible=false
        searchForm={
            name:''
        }
        loading = false;
        dataListSelections=[];
        created() {
          this.searchData();
        }

        handleSizeChange(val) {
            this.pageSize = val;
            this.getUserList();
        }
        handleCurrentChange(val) {
            this.currentNo = val;
            this.searchData();
        }
        // 多选
        selectionChangeHandle (val) {
            this.dataListSelections = val
        }
        addOrUpdate(val) {

            this.addOrUpdateVisible = true
            this.$nextTick
            (() => {
                this.$refs.addOrUpdate.init(val)
            })
        }
        deleteHandle (id) {
            let ids = id ? [id] : this.dataListSelections.map(item => {
                return item.id
            })
            if(!ids || ids.length==0) return
            this.$confirm
            (`确定进行[删除]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                ({
                    url: `/bjba/guest/type/delete`,
                    method: 'post',
                    data: ids
                }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message
                        ({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.searchData()
                    } else if(data && data.code ==500) {
                        this.$message
                        ({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                })
            }).catch(() => {
            })
        }
        changeIndex(){
            this.currentNo =1
        }
        searchData () {
            this.loading = true
            this.searchForm.page = this.currentNo;
            this.searchForm.pagesize = this.pageSize
            this.$request
                    .get('/bjba/guest/type/list',{params:this.searchForm})
                    .then(res => {
            const {data} = res
            this.loading = false
            this.dataList = data.data.content
            this.pageTotal = data.data.totalElements
            }).catch(err => {
            this.$message
            ({
            message: '获取列表出现异常!',
            type: 'error',
            center: true,
            showClose: true
            })
            this.loading = false
            console.log(err)
            })
        }
    }
</script>
<style lang="scss" scoped>
    .bcgl {}
</style>
